module.exports = __webpack_public_path__ + "img/kc-logo.e00f39bf.svg";